import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_first_order_incentive-terms_and_conditions_learn_more-click';

/**
 * Tracks click on learn more button on the first order incentive top banner
 */
export function trackRetailerFirstOrderIncentiveTermsAndConditionsLearnMoreClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
